export default function TextArea(props: {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  const { value, onChange, label, placeholder, disabled } = props;
  return (
    <div className={`flex w-full flex-grow flex-col gap-2`}>
      <label>{label}</label>
      <textarea
        className={`dynamic-focus-border mt-2 h-40 resize-none rounded-md border p-1`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}
